import React from "react";
import { Box, Center, HStack, Icon, Spinner, Text, VStack, Button } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";

export default function EmbeddedFormApp() {
  const [available, setAvailable] = React.useState(null); // null=loading, false=missing, true=ok
  const iframeRef = React.useRef(null);

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const resp = await fetch("/form-app/index.html", { cache: "no-store" });
        if (!alive) return;
        setAvailable(resp.ok);
      } catch (_) {
        if (!alive) return;
        setAvailable(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  if (available === null) {
    return (
      <Center h="70vh">
        <HStack spacing={3}>
          <Spinner />
          <Text>Form uygulaması yükleniyor…</Text>
        </HStack>
      </Center>
    );
  }

  if (!available) {
    return (
      <Center h="70vh">
        <VStack spacing={3}>
          <Text fontWeight="bold">Form uygulaması bulunamadı</Text>
          <Text fontSize="sm" color="gray.500" textAlign="center" maxW="560px">
            Bu entegrasyon, form uygulamasının statik çıktısının bu projenin public/form-app dizininden sunulmasını bekler.
            Lütfen <b>/form-app/nwapp</b> içeriğini <b>frontend/public/form-app</b> altına kopyalayın ve sayfayı yenileyin.
          </Text>
          <Button
            rightIcon={<ExternalLinkIcon />}
            onClick={() => window.open("about:blank", "_self")}
          >
            Yenile
          </Button>
        </VStack>
      </Center>
    );
  }

  return (
    <Box
      border="1px solid"
      borderColor="gray.200"
      borderRadius="xl"
      overflow="hidden"
      height="calc(100vh - 160px)"
      bg="white"
    >
      <iframe
        ref={iframeRef}
        title="Form App"
        src="/form-app/index.html"
        style={{ width: "100%", height: "100%", border: "0" }}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
    </Box>
  );
}

